import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-head-choice',
  templateUrl: './order-head-choice.component.html',
  styleUrls: ['./order-head-choice.component.css']
})
export class OrderHeadChoiceComponent implements OnInit {
    orderHeadChoiceKeyno;

    public edit?: Edit;

    public selectListRelatedChoices: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.orderHeadChoiceKeyno = this.stateService.getStateParams()['orderheadchoice_keyno'];
    }

    private async loadEdit() {
        if (!!this.orderHeadChoiceKeyno) {
            this.edit = (await this.datatask.Post(3745, { orderheadchoice_keyno: this.orderHeadChoiceKeyno }))[0];
        }
    }

    private async loadRelatedChoices() {
        if (!this.edit) return;

        return this.selectListRelatedChoices = await this.datatask.Post(3746, this.edit);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3747, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadRelatedChoices();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    orderheadchoice_keyno: string;
    prod_id_choice: string;
    prod_name_choice: string;
    prod_id_choosed: string;
    choicenote: string;
}
